import { useQuery } from "react-query";
import { supportWidgetApi } from "@circle-react/api/supportWidgetApi";
import { FIFTEEN_MINUTES } from "../constants";
import { clearHistory } from "../utils/locationHistoryManager";

const handleOnError = () => {
  clearHistory();
};

export const useShowPost = (id: string | number) =>
  useQuery(["posts", "details", id], () => supportWidgetApi.showPost(id), {
    onError: handleOnError,
    retry: false,
    staleTime: FIFTEEN_MINUTES,
  });
